import React from 'react'
import { useTranslation } from 'react-i18next'; 

//components
import { GenericTableHeader } from "@surgia/ui";
import Button from "@surgia/ui/components/button";

//containers
import TableToolbar from "@surgia/ui/containers/tableToolBar";
import TenantProductsTable from "../../../containers/tables/tenantProducts-table";

//icons
import addIcon from "@surgia/ui/icons/actions/add.svg";

//helpers
import { handleViewDetails } from "./../helpers";

function Catalog({
  status,
  setStatus,
  search,
  setSearch,
  filtersModalOpen,
  setFiltersModalOpen,
  tenantProductsResponse,
  currentPage,
  totalPages,
  setCurrentPage,
  handleActivate,
  isTenantProductsLoading,
  handleAssignProductsBtnClick,
  // Add sorting props
  handleSort,
  sortState
}) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow pt-4">
      {/* Your existing catalog content */}
      <div className="pt-4">
        <TableToolbar
          additionalChild={
            <Button
              variant="primary"
              startIcon={addIcon}
              onClick={handleAssignProductsBtnClick}
            >
              {t("admin.productAssignment.pageTitle")}
            </Button>
          }
          statusTabs={[]}
          currentStatus={status}
          onStatusChange={setStatus}
          searchValue={search}
          onSearchChange={setSearch}
          onFilterClick={() => setFiltersModalOpen(!filtersModalOpen)}
          showSearch={false}
          children={
            <GenericTableHeader
              titleTranslationKey="admin.tenantDetails.tabs.catalog"
              totalCount={tenantProductsResponse?.total || 0}
              showBadge={true}
              customBadgeText={`${tenantProductsResponse?.total || 0}`}
              showBorder={false}
              padding=""
              layout="basic"
              badgeClassName="!bg-transparent !rounded-sm !border-[#D5D7DA]"
            />
          }
        />
      </div>
      <TenantProductsTable
        data={tenantProductsResponse?.data || []}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        onActivate={handleActivate}
        onViewDetails={handleViewDetails}
        loading={isTenantProductsLoading}
        sortState={sortState}
        onSort={handleSort}
      />
    </div>
  )
}

export default Catalog